export function createLevelsPlugin(): any {
    let plugin: any = {
        name: 'levels',
        display: 'submenu',
        innerHTML: `<div className='header-button'>Levels</div>`,
        buttonClass: 'header-button-wrapper',
        add: function (core: any, targetElement: any) {
            const context = core.context;
            context.levels = {
                targetButton: targetElement,
            };

            // Create tags for each level
            for (let i = 1; i <= 6; i++) {
                const tagName = `L${i}`;
                context[tagName] = {
                    tag: core.util.createElement(tagName)
                };
            }

            /** set submenu */
            let listDiv = this.setSubmenu(core);

            /** add event listeners */
            listDiv.querySelector('.se-list-inner').addEventListener('click', this.pickup.bind(core));

            /** append target button menu */
            core.initMenuTarget(this.name, targetElement, listDiv);
        },
        setSubmenu: function (core: any) {
            const listDiv = core.util.createElement('div');
            listDiv.className = 'se-submenu se-list-layer';

            // Create styling descriptions based on CSS
            const levelDescriptions = [
                'First Level Hierarchy (DIY Styles)',             // L1
                'Indented 5px',                                   // L2
                'Indented 10px',                                  // L3
                'Indented 15px',                                  // L4
                'Indented 20px',                                  // L5
                'Indented 25px'                                   // L6
            ];

            let list = '<div class="se-list-inner">' +
                '<ul class="se-list-basic">';

            for (let i = 1; i <= 6; i++) {
                // Add description to each level button
                list += `<li><button type="button" class="se-btn-list" data-level="${i}" title="Level ${i} (${levelDescriptions[i - 1]})">Level ${i} <small style="opacity: 0.7">${levelDescriptions[i - 1]}</small></button></li>`;
            }

            list += '</ul></div>';
            listDiv.innerHTML = list;
            return listDiv;
        },
        pickup: function (e: any) {
            if (!/^BUTTON$/i.test(e.target.tagName)) return false;

            e.preventDefault();
            e.stopPropagation();

            const level = e.target.getAttribute('data-level');
            if (!level) return false;

            const tagName = `L${level}`;
            const tag = this.context[tagName].tag;

            // Check if the selection is already wrapped with this level
            const currentLevelTag = this.util.getParentElement(this.getSelectionNode(), tagName);

            if (currentLevelTag) {
                // Remove the level tag if it's already applied (toggle behavior)
                this.detachRangeFormatElement(currentLevelTag, null, null, false, false);
            } else {
                // Apply the level tag, removing any other level tags
                const levels = ['L1', 'L2', 'L3', 'L4', 'L5', 'L6'];
                const remainingLevels = levels.filter(l => l !== tagName.toUpperCase());

                // Use nodeChange to apply the new level tag and remove other level tags
                this.nodeChange(tag, null, remainingLevels, null);
            }

            // Add to history for undo functionality and close submenu
            this.history.push(false);
            this.submenuOff();
        },
        // Provide visual feedback for active levels
        active(element: Element | null): boolean {
            if (!element) return false;

            // Check if any level tag is active
            for (let i = 1; i <= 6; i++) {
                const tagName = `L${i}`;
                if (element.nodeName === tagName.toUpperCase()) {
                    const targetButton = this.context.levels.targetButton;
                    this.util.addClass(targetButton, 'active');
                    return true;
                }
            }

            // No level is active
            const targetButton = this.context.levels.targetButton;
            this.util.removeClass(targetButton, 'active');
            return false;
        }
    }
    return plugin;
}